import styled from "styled-components";

import { Color } from "~/shared/styles";

import type { TooltipContainerProps } from "./Tooltip.d";

export const TooltipContainer = styled.div<TooltipContainerProps>`
	background-color: ${Color.TOOLTIP};
	color: ${Color.DARK_TEXT};
	border-radius: 0.25rem;
	padding: 0.25rem;
	left: ${({ $left = 0 }) => $left}px;
	position: ${({ $position }) => $position};
	top: ${({ $top = 0 }) => $top}px;
	width: max-content;
	z-index: 69;

	svg {
		fill: ${Color.TOOLTIP};
	}	
`;
